// import React, { useState, useEffect } from "react";
// import { Container, Row, Col, Form, Button, Card, Table } from "react-bootstrap";
// import { addDoc, collection, Timestamp, getDocs, deleteDoc, doc } from "firebase/firestore";
// import { fireDB } from "../../firebase/FirebaseConfig";
// import { useNavigate } from "react-router-dom";

// const AddTour = () => {
//     const [tourData, setTourData] = useState({
//         location: "",
//         state: "",
//         description: "",
//         imageUrl: "",
//         date: "",
//         inclusions: "",
//         itinerary: "",
//     });

//     const [tours, setTours] = useState([]);
//     const navigate = useNavigate();

//     const handleChange = (e) => {
//         setTourData((prev) => ({
//             ...prev,
//             [e.target.name]: e.target.value,
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!tourData.location || !tourData.description) {
//             alert("Please fill in required fields.");
//             return;
//         }

//         try {
//             await addDoc(collection(fireDB, "tours"), {
//                 ...tourData,
//                 createdAt: Timestamp.now(),
//             });

//             alert("✅ Tour added successfully!");
//             setTourData({
//                 location: "",
//                 state: "",
//                 description: "",
//                 imageUrl: "",
//                 date: "",
//                 inclusions: "",
//                 itinerary: "",
//             });
//             getAllTours(); // refresh table
//         } catch (err) {
//             console.error("Error adding tour:", err);
//             alert("❌ Failed to add tour.");
//         }
//     };

//     const getAllTours = async () => {
//         try {
//             const snapshot = await getDocs(collection(fireDB, "tours"));
//             const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
//             setTours(data);
//         } catch (error) {
//             console.error("Error fetching tours:", error);
//         }
//     };

//     const handleDelete = async (id) => {
//         if (window.confirm("Are you sure you want to delete this tour?")) {
//             try {
//                 await deleteDoc(doc(fireDB, "tours", id));
//                 getAllTours();
//             } catch (err) {
//                 console.error("Error deleting tour:", err);
//                 alert("❌ Delete failed.");
//             }
//         }
//     };

//     const handleEdit = (id) => {
//         navigate(`/admin/edit-tour/${id}`);
//     };

//     useEffect(() => {
//         getAllTours();
//     }, []);

//     return (
//         <section className="py-5">
//             <Container>
//                 <Row>
//                     <Col md={8} className="mx-auto">
//                         <Card className="p-4 shadow border-0 mb-5">
//                             <h3 className="mb-4 text-center">Add New Tour</h3>
//                             <Form onSubmit={handleSubmit}>
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Tour Location</Form.Label>
//                                     <Form.Control
//                                         type="text"
//                                         name="location"
//                                         value={tourData.location}
//                                         onChange={handleChange}
//                                         required
//                                         placeholder="e.g. Dwarka, Rann of Kutch"
//                                     />
//                                 </Form.Group>
//                                 <Form.Group className="mb-3">
//                                     <Form.Label>State</Form.Label>
//                                     <Form.Control
//                                         type="text"
//                                         name="state"
//                                         value={tourData.state}
//                                         onChange={handleChange}
//                                         required
//                                         placeholder="e.g. Gujarat, Rajasthan, Goa"
//                                     />
//                                 </Form.Group>

//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Description</Form.Label>
//                                     <Form.Control
//                                         as="textarea"
//                                         rows={4}
//                                         name="description"
//                                         value={tourData.description}
//                                         onChange={handleChange}
//                                         required
//                                         placeholder="Enter details about this tour"
//                                     />
//                                 </Form.Group>

//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Tour Date (optional)</Form.Label>
//                                     <Form.Control
//                                         type="date"
//                                         name="date"
//                                         value={tourData.date}
//                                         onChange={handleChange}
//                                     />
//                                 </Form.Group>

//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Image URL (optional)</Form.Label>
//                                     <Form.Control
//                                         type="text"
//                                         name="imageUrl"
//                                         value={tourData.imageUrl}
//                                         onChange={handleChange}
//                                         placeholder="https://example.com/image.jpg"
//                                     />
//                                 </Form.Group>

//                                 <Form.Group className="mb-3">
//                                     <Form.Label>Inclusions (comma-separated)</Form.Label>
//                                     <Form.Control
//                                         type="text"
//                                         name="inclusions"
//                                         value={tourData.inclusions}
//                                         onChange={handleChange}
//                                         placeholder="e.g. Hotel, Guide, Transport, Meals"
//                                     />
//                                 </Form.Group>

//                                 <Form.Group className="mb-4">
//                                     <Form.Label>Itinerary</Form.Label>
//                                     <Form.Control
//                                         as="textarea"
//                                         rows={3}
//                                         name="itinerary"
//                                         value={tourData.itinerary}
//                                         onChange={handleChange}
//                                         placeholder="e.g. Day 1: Arrival, Day 2: Sightseeing..."
//                                     />
//                                 </Form.Group>

//                                 <div className="d-grid">
//                                     <Button type="submit" className="primaryBtn btn-lg">
//                                         Add Tour
//                                     </Button>
//                                 </div>
//                             </Form>
//                         </Card>
//                     </Col>
//                 </Row>

//                 {/* All Tours Table */}
//                 <Row>
//                     <Col>
//                         <Card className="p-3 shadow">
//                             <h4 className="mb-3">All Tours</h4>
//                             {tours.length === 0 ? (
//                                 <p>No tours added yet.</p>
//                             ) : (
//                                 <div className="table-responsive">
//                                     <Table striped bordered hover>
//                                         <thead>
//                                             <tr>
//                                                 <th>Image</th>
//                                                 <th>Location</th>
//                                                 <th>Description</th>
//                                                 <th>Date</th>
//                                                 <th>Action</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {tours.map((tour) => (
//                                                 <tr key={tour.id}>
//                                                     <td>
//                                                         <img
//                                                             src={tour.imageUrl || "https://via.placeholder.com/80x60"}
//                                                             alt={tour.location}
//                                                             width="80"
//                                                             height="60"
//                                                         />
//                                                     </td>
//                                                     <td>{tour.location}</td>
//                                                     <td>{tour.description?.slice(0, 50)}...</td>
//                                                     <td>{tour.date || "N/A"}</td>
//                                                     <td>
//                                                         <Button
//                                                             variant="primary"
//                                                             size="sm"
//                                                             className="me-2"
//                                                             onClick={() => handleEdit(tour.id)}
//                                                         >
//                                                             Edit
//                                                         </Button>
//                                                         <Button
//                                                             variant="danger"
//                                                             size="sm"
//                                                             onClick={() => handleDelete(tour.id)}
//                                                         >
//                                                             Delete
//                                                         </Button>
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </Table>
//                                 </div>
//                             )}
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>
//         </section>
//     );
// };

// export default AddTour;
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card, Table } from "react-bootstrap";
import { addDoc, collection, Timestamp, getDocs, deleteDoc, doc } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import { useNavigate } from "react-router-dom";

const states = [
    "Gujarat", "Rajasthan", "Delhi", "Kerala", "Uttar Pradesh", "Uttarakhand", "Himachal Pradesh",
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Haryana", "Jammu Kashmir", "Jharkhand", "Karnataka", "Lakshadweep",
    "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
    "Odisha", "Puducherry", "Punjab", "Sikkim", "Tamil Nadu", "Telangana",
    "Tripura", "West Bengal"
];

const AddTour = () => {
    const [tourData, setTourData] = useState({
        location: "",
        state: "",
        description: "",
        imageUrl: "",
        date: "",
        inclusions: "",
        itinerary: "",
    });

    const [tours, setTours] = useState([]);
    const navigate = useNavigate();

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setTourData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Submit new tour
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!tourData.location || !tourData.state || !tourData.description) {
            alert("Please fill in required fields: Location, State, Description.");
            return;
        }

        try {
            await addDoc(collection(fireDB, "tours"), {
                ...tourData,
                createdAt: Timestamp.now(),
            });
            alert("✅ Tour added successfully!");
            setTourData({
                location: "",
                state: "",
                description: "",
                imageUrl: "",
                date: "",
                inclusions: "",
                itinerary: "",
            });
            getAllTours();
        } catch (err) {
            console.error("Error adding tour:", err);
            alert("❌ Failed to add tour.");
        }
    };

    // Fetch all tours
    const getAllTours = async () => {
        try {
            const snapshot = await getDocs(collection(fireDB, "tours"));
            const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setTours(data);
        } catch (error) {
            console.error("Error fetching tours:", error);
        }
    };

    // Delete tour
    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this tour?")) {
            try {
                await deleteDoc(doc(fireDB, "tours", id));
                getAllTours();
            } catch (err) {
                console.error("Error deleting tour:", err);
                alert("❌ Delete failed.");
            }
        }
    };

    // Edit tour
    const handleEdit = (id) => {
        navigate(`/admin/edit-tour/${id}`);
    };

    useEffect(() => {
        getAllTours();
    }, []);

    return (
        <section className="py-5">
            <Container>
                <Row>
                    <Col md={8} className="mx-auto">
                        <Card className="p-4 shadow border-0 mb-5">
                            <h3 className="mb-4 text-center">Add New Tour</h3>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tour Location</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="location"
                                        value={tourData.location}
                                        onChange={handleChange}
                                        required
                                        placeholder="e.g. Dwarka, Rann of Kutch"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>State</Form.Label>
                                    <Form.Select
                                        name="state"
                                        value={tourData.state}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select State</option>
                                        {states.map((state, idx) => (
                                            <option key={idx} value={state}>
                                                {state}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        name="description"
                                        value={tourData.description}
                                        onChange={handleChange}
                                        required
                                        placeholder="Enter details about this tour"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tour Date (optional)</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="date"
                                        value={tourData.date}
                                        onChange={handleChange}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Image URL (optional)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="imageUrl"
                                        value={tourData.imageUrl}
                                        onChange={handleChange}
                                        placeholder="https://example.com/image.jpg"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Inclusions (comma-separated)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="inclusions"
                                        value={tourData.inclusions}
                                        onChange={handleChange}
                                        placeholder="e.g. Hotel, Guide, Transport, Meals"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label>Itinerary</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="itinerary"
                                        value={tourData.itinerary}
                                        onChange={handleChange}
                                        placeholder="e.g. Day 1: Arrival, Day 2: Sightseeing..."
                                    />
                                </Form.Group>

                                <div className="d-grid">
                                    <Button type="submit" className="primaryBtn btn-lg">
                                        Add Tour
                                    </Button>
                                </div>
                            </Form>
                        </Card>
                    </Col>
                </Row>

                {/* All Tours Table */}
                <Row>
                    <Col>
                        <Card className="p-3 shadow">
                            <h4 className="mb-3">All Tours</h4>
                            {tours.length === 0 ? (
                                <p>No tours added yet.</p>
                            ) : (
                                <div className="table-responsive">
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th>Image</th>
                                                <th>Location</th>
                                                <th>State</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tours.map((tour) => (
                                                <tr key={tour.id}>
                                                    <td>
                                                        <img
                                                            src={tour.imageUrl || "https://via.placeholder.com/80x60"}
                                                            alt={tour.location}
                                                            width="80"
                                                            height="60"
                                                        />
                                                    </td>
                                                    <td>{tour.location}</td>
                                                    <td>{tour.state}</td>
                                                    <td>{tour.description?.slice(0, 50)}...</td>
                                                    <td>{tour.date || "N/A"}</td>
                                                    <td>
                                                        <Button
                                                            variant="primary"
                                                            size="sm"
                                                            className="me-2"
                                                            onClick={() => handleEdit(tour.id)}
                                                        >
                                                            Edit
                                                        </Button>
                                                        <Button
                                                            variant="danger"
                                                            size="sm"
                                                            onClick={() => handleDelete(tour.id)}
                                                        >
                                                            Delete
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AddTour;
